import { useRouter } from 'next/router';

import React from 'react';

import styled from 'styled-components';

import { Modal } from '@components/common/Modal';

const Iframe = styled.iframe`
  min-width: 50vw;
  min-height: 60vh;
  border: none;
`;

const IframeModal: React.FC<{}> = () => {
  const router = useRouter();
  const { query } = router;

  const open = !!query.iframe;

  const handleClose = () => {
    const { iframe, ...restQuery } = router.query;
    router.push(
      {
        pathname: router.pathname,
        query: restQuery,
      },
      undefined,
      { scroll: false }
    );
  };

  return (
    <Modal noPadding cancellable={true} open={open} onClose={handleClose}>
      <Iframe
        // prettier-ignore
        src={`${query.iframe ?? "about:blank"}`}
        width="100%"
        height="100%"
      />
    </Modal>
  );
};

export default IframeModal;
